import { PublicClientApplication } from "@azure/msal-browser";
import config from "../../config";

export const authConfig = {
  clientId: config.azureClientId,
  authority: `https://login.microsoftonline.com/${config.azureAppId}`,
  redirectUri: config.baseUrl,
  postLogoutRedirectUri: config.baseUrl,
  navigateToLoginRequestUrl: true,
  applicationId: config.azureAppId,
};

const cache = {
  cacheLocation: "sessionStorage",
};

const getMsalConfig = () => {
  const msalConfig = {
    auth: authConfig,
    cache: cache,
  };

  return msalConfig;
};

const msalConfig = getMsalConfig();
export const msalInstance = new PublicClientApplication(msalConfig);
